<ng-container *ngIf="content">
  <ul class="list traveler-options pa0 ma0">
    <li
      class="f6 mt3 mt0-ns bb b--light-gray pb3 flex justify-between items-center core-blue"
    >
      <jb-incrementer
        [formControl]="formGroup.controls.adults"
        [label]="content.adults"
        [min]="travelerAllowedRange?.adults.min"
        [max]="travelerAllowedRange?.adults.max"
        [fluidWidth]="true"
        decreaseLabel="remove adult"
        increaseLabel="add adult"
      ></jb-incrementer>
    </li>
    <li class="f6 mt3 bb b--light-gray pb3 flex flex-column core-blue">
      <jb-incrementer
        [formControl]="formGroup.controls.children"
        [label]="content.children.title + ' ' + content.children.subtitle"
        [min]="travelerAllowedRange?.children.min"
        [max]="travelerAllowedRange?.children.max"
        [fluidWidth]="true"
        decreaseLabel="remove children"
        increaseLabel="add children"
      ></jb-incrementer>
      <div
        *ngIf="requireChildAges && childAgesControl?.controls?.length"
        class="pt2 mt1"
      >
        <div
          *ngFor="
            let childAgeControl of childAgesControl.controls;
            let index = index
          "
        >
          <div class="fl w-50" [ngClass]="index % 2 == 0 ? 'pr1' : 'pr0'">
            <jb-select
              class="pt1"
              [placeholder]="childAgeLabels[index]"
              [formControl]="childAgeControl"
              [visibleItemsBeforeScrolling]="4"
            >
              <jb-select-option
                *ngFor="let age of allowedAges"
                [name]="age + ' ' + (content?.yearAbbreviation || 'yr')"
                [value]="age"
                (click)="selectClicked($event)"
              ></jb-select-option>
            </jb-select>
          </div>
        </div>
      </div>
    </li>
    <li
      class="f6 mt3 bb b--light-gray pb3 flex justify-between items-center core-blue"
    >
      <jb-incrementer
        [formControl]="formGroup.controls.infants"
        [label]="content.lapInfants.title + ' ' + content.lapInfants.subtitle"
        [min]="travelerAllowedRange?.infants.min"
        [max]="travelerAllowedRange?.infants.max"
        [fluidWidth]="true"
        decreaseLabel="remove infant"
        increaseLabel="add infant"
      ></jb-incrementer>
    </li>
  </ul>
</ng-container>
